import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/a2ui-gallery/examples')({
  beforeLoad: () => {
    throw Route.redirect({ to: '/a2ui-examples', replace: true, statusCode: 301 });
  },
});
